import React from 'react';
import { pricingPlans } from '../mock';
import { Check } from 'lucide-react';
import { Card } from './ui/card';
import { Button } from './ui/button';

const PricingSection = ({ onOpenModal }) => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <p className="text-sm font-semibold text-[#FFB400] uppercase tracking-wide mb-2">
            OUR PRICING
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-[#2B0A12] mb-4">
            Affordable Trademark Protection Packages
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-3xl mx-auto">
            Choose the package that best fits your business needs. All packages include expert guidance, comprehensive support, and guaranteed results. Protect your brand today with our cost-effective solutions.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-4 max-w-7xl mx-auto">
          {[
            { 
              id: 'basic', 
              name: 'Basic', 
              price: 45, 
              popular: false,
              features: ['Case Review', 'Case Filing', 'Basic Search', 'State E-Filing', 'Trademark Secured', 'Direct Hit Search', 'Dedicated Case Manager']
            },
            { 
              id: 'deluxe', 
              name: 'Deluxe', 
              price: 145, 
              popular: true,
              features: ['Case Review', 'Case Filing', 'Basic Search', 'State E-Filing', 'Trademark Secured', 'Direct Hit Search', 'Dedicated Case Manager']
            },
            { 
              id: 'premium', 
              name: 'Premium', 
              price: 299, 
              popular: false,
              features: ['Case Review (by a TM Expert)', 'Basic Free Trademark Search', 'Trademark Monitoring Services (3 Months)', 'Trademark Secured', 'Refusal Risk Meter', 'Case filing service with complete paperwork']
            },
            { 
              id: 'elite', 
              name: 'Elite', 
              price: 599, 
              popular: false,
              features: ['Case Review & Filing (U.S Registered IP Attorney)', 'Assigned Case Filing Officer', 'Private Registration', 'Trademark Secured', 'Federal Search & Clearance Report (All States)', 'Federal E-Filing (USPTO)', 'Cease & Desist Letter', 'Same Day Filing', 'Trademark Monitoring (1 Year)', 'Direct Hit Search', 'Dedicated Case Manager', '24/7 Secure Online Access', '100% Approval Guarantee']
            }
          ].map((plan, index) => (
            <Card
              key={index}
              className={`w-full md:w-[calc(50%-8px)] lg:w-[calc(25%-12px)] xl:w-[270px] relative overflow-hidden transition-all duration-300 hover:scale-105 bg-white ${
                plan.popular
                  ? 'border-4 border-[#D72638] shadow-2xl scale-105'
                  : 'border-2 border-gray-200 hover:border-[#FFB400] hover:shadow-xl'
              }`}
            >
              {plan.popular && (
                <div className="absolute top-0 right-0 bg-gradient-to-r from-[#D72638] to-[#FFB400] text-white text-xs font-bold px-4 py-1 rounded-bl-lg">
                  POPULAR
                </div>
              )}
              <div className="p-6">
                <h3 className="text-2xl font-bold text-[#2B0A12] mb-4">{plan.name}</h3>
                <div className="mb-6">
                  <span className="text-4xl font-bold text-[#D72638]">${plan.price}</span>
                  <span className="text-gray-600 text-sm">+USPTO fees</span>
                </div>
                <ul className="space-y-3 mb-6 h-[320px] overflow-y-auto pr-2 scrollbar-thin scrollbar-thumb-[#FFB400] scrollbar-track-gray-200">
                  {plan.features.map((feature, i) => (
                    <li key={i} className="flex items-start space-x-2">
                      <Check className="h-5 w-5 text-[#FFB400] flex-shrink-0 mt-0.5" />
                      <span className="text-sm text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>
                <Button
                  onClick={() => onOpenModal && onOpenModal(`Get Started - ${plan.name} Plan`)}
                  className={`w-full font-semibold transition-all duration-300 ${
                    plan.popular
                      ? 'bg-gradient-to-r from-[#D72638] to-[#FFB400] hover:from-[#c21f2f] hover:to-[#e5a200] text-white'
                      : 'bg-[#2B0A12] hover:bg-[#3D1C24] text-white'
                  }`}
                >
                  Get Started
                </Button>
                <p className="text-xs text-gray-500 text-center mt-3">*(Govt. filing fee not included)</p>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingSection;